(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 1101px)');
  var REDUCED_MQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return REDUCED_MQ.matches;
  }

  function isDesktop() {
    return DESKTOP_MQ.matches;
  }

  function lockBodyScroll(locked) {
    if (!locked) return function () {};
    var prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.overflow = prev;
    };
  }

  function updatePointerOffset(event, xName, yName) {
    if (event.pointerType === 'touch') return;
    var el = event.currentTarget;
    var rect = el.getBoundingClientRect();
    var x = ((event.clientX - rect.left) / rect.width - 0.5) * 12;
    var y = ((event.clientY - rect.top) / rect.height - 0.5) * 12;
    el.style.setProperty(xName, Math.max(-6, Math.min(6, x)) + 'px');
    el.style.setProperty(yName, Math.max(-6, Math.min(6, y)) + 'px');
  }

  function resetPointerOffset(el, xName, yName) {
    el.style.setProperty(xName, '0px');
    el.style.setProperty(yName, '0px');
  }

  function bindPointerTilt(el, xName, yName) {
    el.addEventListener('pointermove', function (e) {
      updatePointerOffset(e, xName, yName);
    });
    el.addEventListener('pointerleave', function (e) {
      resetPointerOffset(e.currentTarget, xName, yName);
    });
  }

  function initParallax(el) {
    if (!el || prefersReducedMotion() || !isDesktop()) return;

    var frame = 0;
    function update() {
      frame = 0;
      var rect = el.getBoundingClientRect();
      var distance = rect.top + rect.height / 2 - window.innerHeight / 2;
      var shift = Math.max(-18, Math.min(18, distance * -0.018));
      el.style.setProperty('--parallax-y', shift + 'px');
    }

    function requestUpdate() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    REDUCED_MQ.addEventListener('change', requestUpdate);
    DESKTOP_MQ.addEventListener('change', requestUpdate);
  }

  function initReveal(root) {
    var scope = root || document.querySelector('.dictac-home');
    if (!scope || prefersReducedMotion()) return;

    var page = document.querySelector('.dictac-home');
    if (page) page.classList.add('dictac-motion');

    var elements = scope.querySelectorAll('[data-dictac-reveal]');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('dictac-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6%' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initHorizontalRail(rail, options) {
    if (!rail) return;

    options = options || {};
    var drag = { pointerId: -1, startX: 0, startScroll: 0, moved: false };
    var progressEl = options.progressEl;
    var prevBtn = options.prevBtn;
    var nextBtn = options.nextBtn;

    function updateState() {
      var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      var left = rail.scrollLeft > 4;
      var right = rail.scrollLeft < maxScroll - 4;
      var progress = maxScroll > 0 ? rail.scrollLeft / maxScroll : 0;

      if (prevBtn) prevBtn.disabled = !left;
      if (nextBtn) nextBtn.disabled = !right;
      if (progressEl) {
        var bar = progressEl.querySelector('span');
        if (bar) bar.style.width = 20 + progress * 80 + '%';
      }
    }

    function move(direction) {
      var page = Math.max(1, rail.clientWidth);
      var target = Math.round(rail.scrollLeft / page) + direction;
      rail.scrollTo({ left: target * page, behavior: 'smooth' });
    }

    rail.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState);
    updateState();

    if (prevBtn)
      prevBtn.addEventListener('click', function () {
        move(-1);
      });
    if (nextBtn)
      nextBtn.addEventListener('click', function () {
        move(1);
      });

    rail.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        move(1);
      }
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        move(-1);
      }
    });

    rail.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      if (
        e.target.closest(
          'button, a, input, textarea, select, label, [data-dictac-instagram-card]'
        )
      )
        return;
      drag = {
        pointerId: e.pointerId,
        startX: e.clientX,
        startScroll: rail.scrollLeft,
        moved: false,
      };
      rail.setPointerCapture(e.pointerId);
      rail.classList.add('is-dragging');
    });

    rail.addEventListener('pointermove', function (e) {
      if (drag.pointerId !== e.pointerId) return;
      var delta = e.clientX - drag.startX;
      if (Math.abs(delta) > 5) drag.moved = true;
      rail.scrollLeft = drag.startScroll - delta;
    });

    function finishDrag(e) {
      if (drag.pointerId !== e.pointerId) return;
      if (rail.hasPointerCapture(e.pointerId))
        rail.releasePointerCapture(e.pointerId);
      drag.pointerId = -1;
      rail.classList.remove('is-dragging');
      var page = Math.max(1, rail.clientWidth);
      rail.scrollTo({
        left: Math.round(rail.scrollLeft / page) * page,
        behavior: 'smooth',
      });
    }

    rail.addEventListener('pointerup', finishDrag);
    rail.addEventListener('pointercancel', finishDrag);

    if (options.preventClickOnDrag) {
      rail.addEventListener(
        'click',
        function (e) {
          if (drag.moved) {
            e.preventDefault();
            e.stopPropagation();
            drag.moved = false;
          }
        },
        true
      );
    }

    return { move: move, updateState: updateState };
  }

  function initCategoryCards(root) {
    (root || document)
      .querySelectorAll('[data-dictac-category-card]')
      .forEach(function (card) {
        if (card.dataset.tiltInit) return;
        card.dataset.tiltInit = 'true';
        bindPointerTilt(card, '--category-x', '--category-y');
      });
  }

  function initParallaxBanners(root) {
    (root || document)
      .querySelectorAll('[data-dictac-parallax="true"]')
      .forEach(function (banner) {
        if (banner.dataset.parallaxInit) return;
        banner.dataset.parallaxInit = 'true';
        initParallax(banner);
        bindPointerTilt(banner, '--banner-x', '--banner-y');
      });
  }

  function initDictacSections(root) {
    initCategoryCards(root);
    initParallaxBanners(root);
    initReveal(root || document.querySelector('.dictac-home'));
  }

  window.DictacHome = {
    prefersReducedMotion: prefersReducedMotion,
    isDesktop: isDesktop,
    lockBodyScroll: lockBodyScroll,
    bindPointerTilt: bindPointerTilt,
    initParallax: initParallax,
    initReveal: initReveal,
    initHorizontalRail: initHorizontalRail,
    updatePointerOffset: updatePointerOffset,
    resetPointerOffset: resetPointerOffset,
  };

  document.addEventListener('DOMContentLoaded', function () {
    initDictacSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initDictacSections(event.target);
  });
})();
